import type { ReactiveControllerHost } from 'lit';
import type { IGameController } from './base-controller';
import BlueprintGameController from './integrations/blueprint-game-controller';
import ElkGameController from './integrations/elk-game-controller';
import EmGameController from './integrations/em-game-controller';
import GamesglobalGameController from './integrations/gamesglobal-game-controller';
import GtGameController from './integrations/gt-game-controller';
import HoelleGameController from './integrations/hoelle-game-controller';
import MerkurGameController from './integrations/merkur-game-controller';
import OryxGameController from './integrations/oryx-game-controller';
import PlayngoGameController from './integrations/playngo-game-controller';
import PragmaticGameController from './integrations/pragmatic-game-controller';
import PushGameController from './integrations/push-game-controller';
import SpinomenalGameController from './integrations/spinomenal-game-controller';
import SynotGameController from './integrations/synot-game-controller';
import YggdrasilGameController from './integrations/yggdrasil-game-controller';

type GameControllerKey = keyof typeof gameControllerMap;

const gameControllerMap = {
  bp: BlueprintGameController,
  elk: ElkGameController,
  em: EmGameController,
  gg: GamesglobalGameController,
  gt: GtGameController,
  hoelle: HoelleGameController,
  merkur: MerkurGameController,
  oryx: OryxGameController,
  playngo: PlayngoGameController,
  pragmatic: PragmaticGameController,
  pushgaming: PushGameController,
  spn: SpinomenalGameController,
  synot: SynotGameController,
  ygg: YggdrasilGameController,
};

export function createGameController(host: ReactiveControllerHost, integration: string): IGameController {
  const key = integration as GameControllerKey;
  const ControllerClass = gameControllerMap[key];

  if (ControllerClass) {
    return new ControllerClass(host);
  }
  throw new Error('Unmatched Provider.');
}
